export default __webpack_public_path__ + "image/329cba367dbb458c0291e2e099a0823c.svg";